import { render, staticRenderFns } from "./Icoterm.vue?vue&type=template&id=16ceaf46&"
import script from "./Icoterm.vue?vue&type=script&lang=js&"
export * from "./Icoterm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports